
<div class="w-full flex-1 flex-col md:flex-row flex gap-2 md:gap-4 m-0 justify-between">
  <div
    class="flex-1 ml-1 text-mat-ef-revolution-primary-500"
    >
    @if (filterService(document)) {
      <div
        class="font-efSans text-sm md:text-base font-bold break-words"
        >
        {{ getTranslation(document) }}
      </div>
    }
    <div
      class="font-efSans text-sm md:text-base font-bold break-words"
      >
      {{ document?.brandName }} {{ document?.modelName }}
    </div>
    <div class="font-efSans text-sm md:text-base">
      @if (document?.date && sharedService.dateExists(document?.date)) {
        <span>
          <T
          str="Bring in date"
          key="customerPortal.customer-portal.document-header.bring-in-date"
          tags="customer-portal, 3.26"
        ></T>:
      </span>
    }
    {{
    sharedService.getDocumentDate(document)
    | date: dateFormat
    }}
  </div>
  @if (document?.dealer) {
    <p class="font-efSans text-sm md:text-base">
      {{
      document?.dealer.name
      ? document?.dealer.name +
      (', ' + document?.dealer.subname) || ''
      : ''
      }}
    </p>
  }
  @if (!document?.active) {
    <div
      class="font-efSans text-sm md:text-base"
      >
      <T
      str="Inactive"
      key="customerPortal.customer-portal.status.inactive"
      tags="customer-portal, 3.1"
    ></T>
  </div>
}
</div>

<div
  class="flex flex-col md:basis-1/3 text-mat-ef-revolution-primary-500"
  >
  @if (document?.type) {
    <div
      class="ml-1 font-efSans text-sm md:text-base font-bold break-words"
      >
      <!-- https://emilfreygroup.atlassian.net/browse/CPEFG-3843  -->
      {{
      {
      str:
      document?.type === 'SERVICE'
      ? 'invoice'
      : document?.type?.toLowerCase(),
      prefix: 'customerPortal.customer-portal.'
      } | transifexTranslate
      }}
    </div>
  }

  @if (
    !document?.type &&
    !document?.invNumber &&
    !document?.number
    ) {
    <div
      class="font-efSans text-sm md:text-base font-bold break-words"
      >
      -
    </div>
  }

  @if (document?.invNumber) {
    <p
      class="font-efSans text-sm md:text-base ml-1"
      >
      {{ document?.invNumber }}
    </p>
  }
  @if (document?.number) {
    <p
      class="font-efSans text-sm md:text-base ml-1"
      >
      {{ document?.number }}
    </p>
  }
</div>
</div>













